/*
 Copyright 2024 BFB Labs

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

	  https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/

import React from 'react';
import { Slider } from '@mui/material';

/**
 * Summary.
 * SliderComponent is a Generic Slider component that returns a Slider Component with customisation options.
 * Description. (N/A)
 *
 * @since      0.1.0
 *
 * @param {string}      ariaLabel        		   	Component Label.
 * @param {number}      [defaultValue=0]			Default Value of the Slider.
 * @param {number}      [shiftStep=1] 				Steps the slider shifts on arrow keys press.
 * @param {number}      [step=0.1]  				Granularity of the Slider(Minimum steps it can move).
 * @param {number}      [min=0] 					Minimum value of the Slider.
 * @param {number}      [max=9]        				Maximum Value of Slider.
 * @param {number}      sliderValue					State Value of the Slider.
 * @param {function}    valueSetter 				State Value setter of the Slider.
 * @param {boolean}     sliderTouched  				Slider Touched State Flag
 * @param {function}    setSliderTouched 			Slider Touched Flag Setter
 * @param {boolean}     toggleShowSliderMessage 	Flag that shows or hides slider validation message.
 * @param {function}    changeSliderValue		 	Inherited Function that changes slider value and handles the components value changes.
 *
 * @return {node}   returns Reusable SliderComponent with custom properties and handlers 
 */
const SliderComponent = ({ariaLabel, defaultValue=0, shiftStep=1, step=0.1, min=0, max=9, sliderValue, valueSetter, sliderTouched, setSliderTouched, toggleShowSliderMessage, changeSliderValue}) => {
	return(
		<Slider
			onChange={(e,value) => changeSliderValue(value, valueSetter, sliderTouched, setSliderTouched, toggleShowSliderMessage)}
			value={sliderValue}
			aria-label={ariaLabel}
			defaultValue={defaultValue}
			shiftStep={shiftStep}
			step={step}
			min={min}
			max={max}
		>
		</Slider>
	)
}

export default SliderComponent;